import { render, staticRenderFns } from "./commercialListItemTwoPay.vue?vue&type=template&id=7572a7cc"
import script from "./commercialListItemTwoPay.vue?vue&type=script&lang=js"
export * from "./commercialListItemTwoPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports